module.exports = __webpack_public_path__ + "img/Facebook-icon-min.98b1f07b.svg";